module.exports = __webpack_public_path__ + "img/logo_half_closed.8ed0eb2e.svg";